import React from 'react';

import './buttonWrap.scss';

const ButtonWrap = ({children}) => <div className="buttonWrap">{children}</div>;

export default ButtonWrap;